import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "index2",
    redirect: "/index",
    meta: {
      title: "广东珠江化工涂料有限公司",
      content: {
        description:
          "广东珠江化工涂料有限公司（以下简称“珠涂公司”）是广州工业投资控股集团有限公司属下国有全资二级企业，总投资额达5亿元，占地面积11.7万平方米，旗下有沈阳派尔化学有限公司、珠海万力新材料科技有限公司、广州万力涂料有限公司等控股及全资企业，拥有80多年的涂料历史，是中国最早创立的民族涂料企业之一，也是目前我国生产装备先进、综合性强、持有尖端核心生产工艺技术的国家高新技术企业。 公司拥有“电视塔”牌、“青竹”牌、“青松”牌、“南方”牌、“东风”牌、“施能”牌等六大品牌，自90年代末，“电视塔”牌、“青竹”牌均获得省、市著名品牌和著名商标等荣誉，并一直蝉联至今，更是历年“经销商最喜爱的中国十大工业涂料品牌金漆奖”等多项荣誉的获得者，载誉而归。经过近百年的潜心经营，现珠涂公司销售网络已立足华南，辐射全国，产品先后应用于大亚湾和岭澳核电站、琶洲会展中心、广州新火车站等多项政府工程，在工业防护涂料领域具有良好的口碑和知名度，销售量居华南地区前列。 现时，珠涂公司秉承“永远进取，永远创新，永不言败，永续发展”的精神，积极走新型、环保、绿色、节能的现代化企业发展之路。"
      }
    }

    // component: () => import('@/views/index')
  },
  {
    path: "/index",
    name: "index",

    meta: {
      title: "广东珠江化工涂料有限公司",
      content: {
        description:
          "广东珠江化工涂料有限公司（以下简称“珠涂公司”）是广州工业投资控股集团有限公司属下国有全资二级企业，总投资额达5亿元，占地面积11.7万平方米，旗下有沈阳派尔化学有限公司、珠海万力新材料科技有限公司、广州万力涂料有限公司等控股及全资企业，拥有80多年的涂料历史，是中国最早创立的民族涂料企业之一，也是目前我国生产装备先进、综合性强、持有尖端核心生产工艺技术的国家高新技术企业。 公司拥有“电视塔”牌、“青竹”牌、“青松”牌、“南方”牌、“东风”牌、“施能”牌等六大品牌，自90年代末，“电视塔”牌、“青竹”牌均获得省、市著名品牌和著名商标等荣誉，并一直蝉联至今，更是历年“经销商最喜爱的中国十大工业涂料品牌金漆奖”等多项荣誉的获得者，载誉而归。经过近百年的潜心经营，现珠涂公司销售网络已立足华南，辐射全国，产品先后应用于大亚湾和岭澳核电站、琶洲会展中心、广州新火车站等多项政府工程，在工业防护涂料领域具有良好的口碑和知名度，销售量居华南地区前列。 现时，珠涂公司秉承“永远进取，永远创新，永不言败，永续发展”的精神，积极走新型、环保、绿色、节能的现代化企业发展之路。"
      }
    },
    component: () => import("@/views/index")
  },
  {
    path: "/enterZT",
    name: "enterZT",
    meta: {
      title: "走进珠涂"
    },
    component: () => import("@/views/enterZT"),
    children: [
      {
        path: "/",
        name: "company",
        meta: {
          title: "走进珠涂"
        },
        component: () => import("@/views/enterZT/enterZT01")
      },
      {
        path: "event",
        name: "event",
        meta: {
          title: "走进珠涂"
        },
        component: () => import("@/views/enterZT/enterZT02")
      },
      {
        path: "research",
        name: "research",
        meta: {
          title: "走进珠涂"
        },
        component: () => import("@/views/enterZT/enterZT03")
      },
      {
        path: "network",
        name: "network",
        meta: {
          title: "走进珠涂"
        },
        component: () => import("@/views/enterZT/enterZT04")
      },
      {
        path: "project",
        name: "project",
        meta: {
          title: "走进珠涂"
        },
        component: () => import("@/views/enterZT/enterZT05")
      },
      {
        path: "jobs",
        name: "jobs",
        meta: {
          title: "走进珠涂"
        },
        component: () => import("@/views/enterZT/enterZT06")
      }
    ]
  },
  {
    path: "/houses",
    name: "houses",
    meta: {
      title: "品牌家族"
    },
    component: () => import("@/views/houses"),
    redirect: "/houses/houses01",
    children: [
      {
        path: "/",
        name: "houses01",
        meta: {
          title: "品牌家族"
        },
        component: () => import("@/views/houses/houses1")
      },
      {
        path: "houses2",
        name: "houses2",
        meta: {
          title: "品牌家族"
        },
        component: () => import("@/views/houses/houses2")
      },
      {
        path: "houses3",
        name: "houses3",
        meta: {
          title: "品牌家族"
        },
        component: () => import("@/views/houses/houses3")
      },
      {
        path: "houses4/:id",
        name: "houses4",
        meta: {
          title: "品牌家族"
        },
        component: () => import("@/views/houses/houses4")
      }
    ]
  },
  {
    path: "/materials",
    name: "materials",
    meta: {
      title: "万力新材料"
    },
    component: () => import("@/views/materials/index")
  },
  {
    path: "/product",
    name: "product",
    meta: {
      title: "产品中心"
    },
    component: () => import("@/views/product"),
    redirect: "/product/shoplist",
    children: [
      {
        path: "/",
        name: "shoplist",
        meta: {
          title: "产品中心"
        },
        component: () => import("@/views/product/shoplist")
      },
      {
        path: "prodetail",
        name: "prodetail",
        meta: {
          title: "产品中心"
        },
        component: () => import("@/views/product/detail")
      },
      {
        path: "sxshoplist",
        name: "sxshoplist",
        meta: {
          title: "产品中心"
        },
        component: () => import("@/views/product/sxshoplist")
      },
      {
        path: "sxprodet",
        name: "sxprodet",
        meta: {
          title: "产品中心"
        },
        component: () => import("@/views/product/sxprodet")
      }
    ]
  },
  {
    path: "/technology",
    name: "technology",
    meta: {
      title: "服务支持"
    },
    component: () => import("@/views/technology")
  },
  {
    path: "/news",
    name: "news",
    meta: {
      title: "新闻动态"
    },
    children: [
      {
        path: "newsDetail",
        name: "newsDetail",
        meta: {
          title: "新闻动态"
        },
        component: () => import("@/views/news/newdetail")
      },
      {
        path: "/",
        name: "news",
        meta: {
          title: "新闻动态"
        },
        component: () => import("@/views/news/newslist")
      }
    ],
    component: () => import("@/views/news")
  },
  {
    path: "/concact",
    name: "concact",
    meta: {
      title: "联系我们"
    },
    component: () => import("@/views/concact")
  },
  {
    path: "/star",
    name: "star",
    meta: {
      title: "明星产品"
    },
    component: () => import("@/views/stars")
  },
  {
    path: "/landing",
    name: "landing",
    meta: {
      title: "详情"
    },
    component: () => import("@/views/landing")
  }
]

const router = new VueRouter({
  linkActiveClass: "router-link-active", // 这是链接激活时的class
  // mode: 'history',
  routes: routes
})
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0
  // console.log("路由守卫", to)
  window.sessionStorage.setItem("routerName", to.name)

  // console.log("路由守卫", window.sessionStorage.getItem("routerName"))

  // if(to.meta.content){
  //   let head = document.getElementsByTagName('head');
  //   let meta = document.createElement('meta');
  //   document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
  //   meta.content = to.meta.content;
  //   head[0].appendChild(meta)
  // }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

//判断路由进行赋值
// function pdrouter(){
//   switch(to.name){
//     case"":
//     this.$state
//   }
// }

export default router
